import React, { useEffect, useState, useCallback } from 'react';
import { Section } from '../layout';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { getFillterBlogs, deleteBlog, ClearBlog } from '../../redux/actions/blogs';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { Loader } from '../../components/utils';
import axios from "axios"
import { DataGrid } from '@mui/x-data-grid';
import {
  DeletButtonStyle,
  DeleteonBlur,
  DeleteonFocus,
  DeleteonMouseEnter,
  DeleteonMouseLeave,
  EditButtonStyle,
  EditonBlur,
  EditonFocus,
  EditonMouseEnter,
  EditonMouseLeave,
  localeTextGrid,
} from "../../constants";
import { ThemeProvider, createTheme } from '@mui/material';
import { useStateContext } from '../../context/ContextProvider';
import { BaseUrl, media } from '../../server';
import { SpinButton, Spiner } from '../utils/Form';
import {truncateTitle} from "../../middleware/truncateTitle"
import { Button } from "@mui/material";
import { Fillter } from './utils';
import { getFillterBooks } from '../../redux/actions/books';
function DAllBooks() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { currentDir } = useStateContext();
  const [isSpinner, setIsSpinner] = useState(false);
  const [titleAr, setTitleAr] = useState('');
  const [titleEn, setTitleEn] = useState('');
  const [date, setDate] = useState('');
  const [categoryId, setCategoryId] = useState("")
  const navigate = useNavigate();
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });

  const page = paginationModel.page;
  const limit = paginationModel.pageSize;


  useEffect(() => {
   
    dispatch(getFillterBooks(page, limit,titleAr, titleEn, date ));
  }, [page, limit,titleAr, titleEn, date ,dispatch]);

  const { isLoading, FillterBooks, pagination } = useSelector((state) => state.Books);



  const deleteBookHandel = async (id) => {
    setIsSpinner(true);
    try {
     const {data} =  await axios.delete(`${BaseUrl}/books/${id}`,  { withCredentials: true });

      if(data.success){
        toast.success(<span className="font-kufi text-tcolor-4 dark:text-tcolor-1 text-sm">{t("Book deleted successfully!")}</span>);
        setIsSpinner(false);
        dispatch(getFillterBooks(page, limit, titleAr, titleEn, date));
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
      setIsSpinner(false);
    }
  };

  const UpdateBookHandeler = (id) => {
  
    navigate(`/EditBookPage/${id}`);
  };

  const theme = createTheme({
    direction: currentDir
  });

  const totalPages = pagination?.totalPages || 0;
  const totalItems = pagination?.totalItems || 0; // إضافة هذا إذا كان الخادم يعيد إجمالي العناصر
  const columns = [
    {
      field: 'titleAr',
      headerName: t('Title (Ar)'),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 200,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center pt-4">
            <p className="font-medium text-sm font-kufi">{truncateTitle(params.value , 3)}</p>
          </div>
        )
      }
    },
    {
      field: 'titleEn',
      headerName: t('Title (En)'),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 200,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center pt-4">
                <p className="font-medium text-sm font-kufi">{truncateTitle(params.value , 3)}</p>
          </div>
        )
      }
    },
   

    {
      field: 'date',
      headerName:  t('Date') ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 120,
   
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center">
            <p className="font-kufi">{params.value} </p>
          </div>
        )
      }
    },
    {
      field: 'Image',
      headerName:  t('Image') ,
      headerClassName: 'font-semibold text-sm font-kufi',
      minWidth: 100,
      flex: 0.7,
      filterable: false, // تعطيل الفلتر لهذا العمود
      renderCell: (params) => {
        return (
          <div
            style={{
              borderRadius: "10%",
              padding:"2px",
              width: "50px",
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50px"
            }}
          >
            <img
              src={`${media}${params.value}`}
              alt="Product Image"
              style={{
                height: "100%",
                width: "auto",
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "cover",
                borderRadius: "50%",
              }}
            />
          </div>
        );
      },
    },
    {
      field: 'actions',
      headerName: t('Actions') ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 150,
      filterable: false, // تعطيل الفلتر لهذا العمود
      renderCell: (params) => {
        return (<>
   <div className="flex pt-2 w-[150px] gap-2 items-center ">
   <Button className="rounded-full" 
      style={DeletButtonStyle}
      onMouseEnter={DeleteonMouseEnter}
      onMouseLeave={DeleteonMouseLeave}
      onFocus={DeleteonFocus}
      onBlur={DeleteonBlur}
        onClick={() => deleteBookHandel(params.row._id)}
        >
       {isSpinner ? <Spiner fillColor={"fill-gray-300"} /> :<span className="body-2">{t("Delete")}</span>}  
</Button>
<Button className="rounded-full"
        style={EditButtonStyle}
        onMouseEnter={EditonMouseEnter}
        onMouseLeave={EditonMouseLeave}
        onFocus={EditonFocus}
        onBlur={EditonBlur} 
        onClick={() => UpdateBookHandeler(params.row._id)}
        >
         <span className='body-2'>{t("Edit")}</span> 
</Button>
          
   </div>
        
         </>
        );
      }
    },
  ];



  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (

        <div className="flex-col  lg:p-16 py-14 px-5 w-full items-center ">
        <h2 className="h2 text-color-1 text-center  dark:text-tcolor-1 mb-4 md:mb-8">{t("Books")}</h2>
            <Fillter titleAr={titleAr} setTitleAr={setTitleAr} titleEn={titleEn} setTitleEn={setTitleEn} date={date} setDate={setDate}  categoryId={categoryId} setCategoryId={setCategoryId} />
            <div className=" items-center  relative justify-center  md:m-10 mt-24 p-2 md:p-10 h-auto bg-white rounded-3xl">
  <ThemeProvider theme={theme}>
    <div style={{ width: '100%', overflowX: 'auto' }}>
                <DataGrid
                  rows={FillterBooks}
                  columns={columns}
                  disableRowSelectionOnClick
                  sx={{ minWidth: '1000px' }}     
                  pagination
                  paginationMode="server"
                  rowCount={totalItems} // Total number of items
                  paginationModel={paginationModel}
                  onPaginationModelChange={setPaginationModel}
                  pageSizeOptions={[paginationModel.pageSize]}
                  getRowId={(row) => row._id} // Use _id as the unique identifier
                  localeText={localeTextGrid} // تمرير الترجمات
                />
             </div>
  </ThemeProvider>
</div></div>
      )}
    </>
  );
}

export default DAllBooks;